export default __webpack_public_path__ + "static/media/chi.c1963b18.jpg";